module.exports = __webpack_public_path__ + "img/mobile/Prompts-gameintro/start-down@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Prompts-gameintro/start-down@2x.png
// module id = 732
// module chunks = 0